import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { getAuth,  onAuthStateChanged, signOut } from "firebase/auth";
import {firebaseApp} from "./firebaseConfig";
import Sidebar from "./components/Sidebar";
import Workspaces from "./pages/Workspaces";
import Users from "./pages/Users";
import AddOns from "./pages/AddOns";
import AppPage from "./pages/AppPage";
import Devices from "./pages/Devices";
import Login from "./components/Login";
import PendingRequests from "./pages/PendingRequests";

const auth = getAuth(firebaseApp);


const AdminPanel = ({ onLogout }) => (
  <div className="admin-container">
    <Sidebar onLogout={onLogout} />
    <div className="content">
      <Routes>
        <Route path="/workspaces" element={<Workspaces />} />
        <Route path="/users" element={<Users />} />
        <Route path="/addons" element={<AddOns />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/pending-requests" element={<PendingRequests />} />
        <Route path="*" element={<Navigate to="/workspaces" />} />
      </Routes>
    </div>
  </div>
);

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => setUser(user));
  }, []);

  return (
    <Router>
      {user ? <AdminPanel onLogout={() => signOut(auth)} /> : <Login onLogin={() => setUser(auth.currentUser)} />}
    </Router>
  );
};

export default App;
